import styled from 'styled-components';
import { InfoButtonStyled } from '../InfoButtonStyled';
export const InfoButtonStyledAP = styled(InfoButtonStyled)``;
